import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import moment from 'moment'
import merge from 'deepmerge'
import {
  mergeIds,
  compressAndFilter,
  getParams,
  computeFaceCount,
  compactAndFilter,
} from '@/utils'

const defaultParams = {
  from: moment().format('YYYY-MM-DD'),
  to: moment().add(30, 'days').format('YYYY-MM-DD'),
}
const module = 'available'
let doc = {
  list: {
    name: 'Disponibilités',
    hasMap: true,
    headers: [
      { label: 'Code', value: 'full_code' },
      { label: 'Type', value: 'board.board_type.name' },
      { label: 'Dimensions', value: 'board.board_type.dimensions', card: false },
      { label: 'Surface (m2)', value: 'board.board_type.surface', card: false },
      { label: 'Adresse', value: 'board.adress' },
      { label: 'District', value: 'board.district.name' },
      { label: 'Ville', value: 'board.district.city.name' },
      { label: 'Région', value: 'board.district.city.region.name' },
      // { label: 'Reservations', value: 'matches' },
    ],
    actions: [
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `faces/goTo` },
      { icon: 'pie_chart', context: {field: 'id'}, dispatch: `tenancy/getTenancy` },
    ],
    search: [
      { label: 'Du', type: 'date', name: 'from', classes: 'md6' },
      { label: 'Au', type: 'date', name: 'to', classes: 'md6' },
      { label: 'Région', type: 'multilist', name: 'region_id', from: 'name', source: 'regions' },
      { label: 'Ville', type: 'multilist', name: 'city_id', from: 'name', source: 'cities' },
      { label: 'District', type: 'multilist', name: 'district_id', from: 'name', source: 'districts' },
      { label: 'Type', type: 'multilist', name: 'board_type_id', from: 'name', source: 'boardtypes' },
    ],
    selectActions: [
      {
        label: 'Rapport',
        icon: 'assignment',
        dispatch: `${module}/report`,
      },
      {
        label: 'Occupation',
        icon: 'pie_chart',
        dispatch: `tenancy/getMultiTenancy`,
        context: {field: 'id'},
      },
    ],
  },

  form: {},

  params: {
    fetchAll: {include: 'board.board_type,board.district.city.region', ...defaultParams},
    fetchOne: {
      include: 'board.board_type,board.district.city.region,displays,bookings.basket.client',
      ...defaultParams,
    },
  },

  postprocess: item => {
    let position = item.board ? {lng: parseFloat(item.board.lon), lat: parseFloat(item.board.lat)} : undefined
    let matches = item.bookings.map(b => {
      let start = moment(b.basket.date_start).format('DD/MM/YYYY')
      let end = moment(b.basket.date_end).format('DD/MM/YYYY')
      return `${start} - ${end}`
    }).join(', ')
    return {
      ...item,
      position,
      matches,
    }
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  state: {
    search: {
      data: defaultParams,
    },
  },
  actions: {
    fetchAll: ({ commit }, payload) => {
      commit('SET_LOADING', true)
      const { data, context } = payload
      commit('LIST_REQUEST', payload)
      let compacted = compactAndFilter(data)
      let params = getParams(context)
      apiClient.fetchAll(module, {...params, ...compacted})
        .then(data => {
          let recomputed = computeFaceCount(data)
          commit('LIST_SUCCESS', recomputed)
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('LIST_ERROR', error)
          commit('SET_LOADING', false)
        })
    },
    report: ({ commit }, payload) => {
      commit('SET_LOADING', true)
      const { data, context } = payload
      commit('EXPORT_REQUEST', payload)
      const contextParams = context.params ? context.params : {}
      const params = {id: mergeIds(data), ...contextParams}
      let cleaned = compressAndFilter(params)
      const callBack = event => { commit('EXPORT_PROGRESS', event) }
      apiClient._download('faces', `reports/available`, {}, cleaned, callBack)
        .then(response => {
          commit('EXPORT_SUCCESS', response)
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('EXPORT_ERROR', error)
          commit('SET_LOADING', false)
        })
    },
  },
}
export default merge(base, custom)
